import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RouteEntity } from '@core/router/router.entity';
import { RouterQueryParams } from '@core/router/router.query-params';
import { UserState } from '@core/state/user.state';
import { SnackBarType } from '@shared/components/snack-bar/snack-bar.component';
import { SnackBarService } from '@shared/components/snack-bar/snack-bar.service';


@Component({
    selector: 'app-auth-callback',
    standalone: true,
    imports: [],
    templateUrl: './auth-callback.component.html',
    styleUrl: './auth-callback.component.scss',
})
export class AuthCallbackComponent {
    readonly #router: Router = inject(Router);
    readonly #push: SnackBarService = inject(SnackBarService);
    readonly #route: ActivatedRoute = inject(ActivatedRoute);
    readonly #userState: UserState = inject(UserState);

    readonly #error: string = this.#route.snapshot.queryParamMap.get(RouterQueryParams.Error);
    readonly #token: string = this.#route.snapshot.queryParamMap.get(RouterQueryParams.Token);

    constructor() {
        if (this.#token) {
            this.#userState.provideOauthResultInRoamingByToken(this.#token);
        }

        if (this.#error) {
            this.#push.open({
                text: this.#error,
                type: SnackBarType.Error,
            });

            this.#router.navigate([RouteEntity.Root, RouteEntity.Login]);
        }
    }
}
